import script from "./Contents-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Contents-big.vue?vue&type=script&setup=true&lang=js"

import "./Contents-big.vue?vue&type=style&index=0&id=1882032a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1882032a"]])

export default __exports__